// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tag_wrapper___UFkp","button":"Tag_button__rUF1S"};